import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import { apiFetch } from '@/core';
import env from '@/env';

export const downloadFileFromAuditorVisit = async ({
  id,
  fileId,
}: {
  id: string;
  fileId: string;
}): Promise<Response> => {
  const fetchResponse = await apiFetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/auditor-visits/${id}/documents/${fileId}/download`,
    { method: 'GET' }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  return fetchResponse;
};
